import { z } from "zod";

export const validateEmail = (requiredMessage: string, invalidEmailMessage: string) => (value: string) => {
  const result = z.string().trim().min(1, requiredMessage).email(invalidEmailMessage).safeParse(value);

  return result.success ? true : result.error.issues[0].message;
};
